import React from 'react';
import { Link } from 'react-router-dom';
import './MonitorHead.css';

interface MonitorHeadProps {
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
  backTo?: string;
  backLabel?: string;
  aside?: React.ReactNode;
}

export const MonitorHead: React.FC<MonitorHeadProps> = ({
  title,
  subtitle,
  icon,
  backTo,
  backLabel,
  aside,
}) => (
  <div className="monitor-head">
    <div className="monitor-head__main">
      <span className="monitor-head__icon" aria-hidden>{icon}</span>
      <div>
        {backTo && backLabel && (
          <Link to={backTo} className="monitor-head__back">{backLabel}</Link>
        )}
        <h1 className={backTo ? 'monitor-head__kicker' : undefined}>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
    </div>
    {aside}
  </div>
);

export default MonitorHead;
